 
import type { User } from 'api/data.types'

export const initHotjar = () => {
  ;((h, o, t, j, a, r) => {
    h.hj =
      h.hj ||
      function () {
        // eslint-disable-next-line prefer-rest-params
        ;(h.hj.q = h.hj.q || []).push(arguments)
      }
    h._hjSettings = { hjid: 2004878, hjsv: 6 }
    a = o.getElementsByTagName('head')[0]
    r = o.createElement('script')
    r.async = 1
    r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv
    a.appendChild(r)
  })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=')
}

export const setHotJarUserData = (user: User) => {
  if (window.hj) {
    window.hj('identify', user?.id, {
      entity_id: user?.reader?.entity?.id,
      entity_degree: user?.reader?.entity?.degree,
      root_id: user?.reader?.root?.id,
      isTeacher: Boolean(user?.teacher),
      products: 'arvore-livros',
      acervo_type: user?.reader?.root?.root_acervo,
      contract_info: user?.reader?.entity?.contractInfo?.type
    })
  }
}

export const hotjarEvent = (eventName: string) => {
  if (window.hj) window.hj('event', eventName)
}

export const hotjarEventWithParams = (
  eventName: string,
  params: number | string | object
) => {
  if (window.hj) window.hj('event', eventName, params)
}
